import {
  Grid,
  Dialog,
  DialogContent,
  Button,
  TextField,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import CurrencyFormat from 'react-currency-format';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatCustomDate } from '../../helpers/formatCustomDate';
import { formatCustomNumber } from '../../helpers/formatCustomNumber';
import DeleteIcon from '@mui/icons-material/Delete';
import SalesReturnItemList from './salesReturnItemsList';
import { salesService } from '../../services/sales.service';
import StatusBadge from '../../generals/StatusBadge';

function SalesOrderReturnOverview(props) {
  const { salesData, id, tableData, imageList = [], updateSalesOrderItems } = props;
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [displayTableData, setDisplayTableData] = useState(tableData);
  const [editOpen, setEditOpen] = useState(false);
  const [editTableData, setEditTableData] = useState([]);

  useEffect(() => {
    setDisplayTableData(tableData);
  }, [tableData]);


  // View sales order in a new tab
  function viewSalesOrder(subId) {
    const url = `/${currModuleId}/Inventory/sales-order/details/${subId}`;
    window.open(url, '_blank');
  }


  const handleEditOpen = () => {
    setEditTableData([...displayTableData]);
    setEditOpen(true);
  };


  const handleEditClose = () => {
    setEditOpen(false);
  };


  const handleQuantityChange = (index, value) => {
    const newData = [...editTableData];
    newData[index].item_return_quantity = parseFloat(value) || 0;
    setEditTableData(newData);
  };



  const handleSalesQuantityChange = (index, value) => {
    const newData = [...editTableData];
    newData[index].sales_order_quantity = parseFloat(value) || 0;
    setEditTableData(newData);
  };



  const handleDelete = index => {
    const newData = [...editTableData];
    newData.splice(index, 1);
    setEditTableData(newData);
  };

  const handleSave = async () => {
    let tempString = '';
    editTableData.forEach((item)=> {
      tempString += `<a>  <item_id>${item?.item_id} </item_id>  <return_quantity>${item?.item_return_quantity}</return_quantity></a>`;
    });
    let baseString = ` <root>${tempString}</root>`;
    const formData = { return_ref_no: id, xml_string_item: baseString };
    updateSalesOrderItems(formData);
   
    setEditOpen(false);
  };




  const handleImageClick = img => {
    setSelectedImage(img);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <section className="mt-8 w-full text-gray-800 max-w-7xl mx-auto">
      {/* Header */}
      <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-100">
        {/* Order Details */}
        <div className="w-full">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Return Order Reference: <span className="text-indigo-600 italic">{salesData?.return_ref_no}</span>
          </h2>
          <p className="text-lg">
            Sales Order:{' '}
            <span
              onClick={() => viewSalesOrder(salesData?.sales_order_ref_no)}
              className="text-indigo-600 italic font-semibold hover:text-indigo-800 cursor-pointer transition-colors"
            >
              {salesData?.sales_order_no}
            </span>
          </p>
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <p>
              <span className="font-medium">Customer Name:</span> {salesData?.customer_full_name}
            </p>
            <p>
              <span className="font-medium">Customer Email:</span> {salesData?.customer_email_address}
            </p>
            <p>
              <span className="font-medium">Customer Mobile:</span> {salesData?.customer_mobile_no}
            </p>
            <p>
              <span className="font-medium">Return Date:</span> {formatCustomDate(salesData?.return_date) || 'N/A'}
            </p>
            <p>
              <span className="font-medium">Reason:</span> {salesData?.reason_name || 'N/A'}
            </p>
            <p>
              <span className="font-medium">Remark:</span> {salesData?.remark_mst || 'N/A'}
            </p>
          </div>
        </div>
        {/* Status and Shipping */}
        <div className="mt-6 flex flex-col md:flex-row justify-between items-center">
          <div className="text-center md:text-left">
            <p className="text-base font-semibold text-gray-700 mb-2">Shipping Address</p>
            <p className="text-sm text-gray-600">{salesData?.order_recipient_full_shipping_address || 'N/A'}</p>
          </div>
          <div className="py-2 rounded  text-right text-lg font-semibold mb-4">
            <StatusBadge
              statusId={salesData?.return_status_id}
              statusName={salesData?.return_status_name}
              size="md"
            />
          </div>
        </div>
      </div>

      {/* Returned Items Section */}
      {displayTableData?.length === 0 ? (
        <div className="bg-white rounded-xl shadow-lg p-6 text-center border border-gray-100">
          <h4 className="text-xl font-bold text-indigo-600">No Return Item(s) to Display</h4>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
          <div className="flex justify-between items-center mb-4">
            <h4 className="text-xl font-bold text-gray-900">Returned Item(s)</h4>
            <Button variant="outlined" onClick={handleEditOpen}>
              Edit Items
            </Button>
          </div>
          <div className="overflow-y-auto max-h-80 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
            <SalesReturnItemList salesData={salesData} tableData={displayTableData} />
          </div>
        </div>
      )}

      {/* Edit Modal */}
      <Dialog open={editOpen} onClose={handleEditClose} maxWidth="lg" fullWidth>
        <DialogContent>
          <div className="p-4">
            <h4 className="text-xl font-bold text-gray-900 mb-4">Edit Returned Items</h4>
            <TableContainer>
              <Table sx={{ minWidth: 650 }} aria-label="editable table">
                <colgroup>
                  <col style={{ width: '40%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '10%' }} />
                </colgroup>
                <TableHead style={{ backgroundColor: '#F1F1F1' }}>
                  <TableRow>
                    <TableCell className="subheading">Returned item(s) Details</TableCell>
                    <TableCell className="subheading">Unit</TableCell>
                    <TableCell className="subheading">Order Quantity</TableCell>
                    <TableCell className="subheading">Return Quantity</TableCell>
                    {/* <TableCell className="subheading">Sales Quantity</TableCell> */}
                    <TableCell className="subheading">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {editTableData?.map((item, i) => (
                    <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell className="subheading" align="left">
                        {item.item_name}
                      </TableCell>
                      <TableCell className="subheading" align="left">
                        {item.item_description}
                      </TableCell>
                      <TableCell className="subheading" align="left">
                        {item.sales_order_quantity}
                      </TableCell>
                      <TableCell className="subheading" align="left">
                        <TextField
                          size="small"
                          type="number"
                          value={item.item_return_quantity || 0}
                          onChange={e => handleQuantityChange(i, e.target.value)}
                          InputProps={{
                            style: { width: '80px' },
                          }}
                        />
                      </TableCell>
                      {/* <TableCell className="subheading" align="left">
                        <TextField
                          size="small"
                          type="number"
                          value={item.sales_order_quantity || 0}
                          onChange={e => handleSalesQuantityChange(i, e.target.value)}
                          InputProps={{
                            style: { width: '80px' },
                          }}
                        />
                      </TableCell> */}

                      <TableCell className="subheading" align="left">
                        <IconButton onClick={() => handleDelete(i)} size="small">
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="flex justify-end mt-4 space-x-2">
              <Button variant="outlined" onClick={handleEditClose}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSave}>
                Save Changes
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Images Section */}
      {imageList.length > 0 && (
        <div className="bg-white rounded-xl shadow-lg p-6 mt-6 border border-gray-100">
          <h4 className="text-xl font-bold text-gray-900 text-center mb-4">Order Images</h4>
          <Grid container spacing={2}>
            {imageList.map((imgData, idx) => (
              <Grid item xs={4} sm={3} md={2} key={idx}>
                <img
                  src={imgData?.image_url}
                  alt={`Order_pic ${idx + 1}`}
                  className="w-full h-20 object-cover rounded cursor-pointer hover:opacity-80 transition-opacity"
                  onClick={() => handleImageClick(imgData?.image_url)}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      )}

      {/* Image Modal */}
      <Dialog open={open} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogContent>
          <img src={selectedImage} alt="Enlarged order image" style={{ width: '80%', height: 'auto' }} />
        </DialogContent>
      </Dialog>
    </section>
  );
}

export default SalesOrderReturnOverview;
